const pageSizeOptions = {
  small: 10,
  medium: 20,
  large: 50,
}

export default pageSizeOptions
